import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { GlgPopupForm, GlgFormInput, GlgSelect } from 'SharedComponents'
import { getFromLeaguesOptions } from '../../../../selectors'

const SelectEventToClone = ({ details, setDetails, fromLeaguesOptions, getLeagueFieldDataSimGolf }) => {
  useEffect(() => {
    getLeagueFieldDataSimGolf()
  }, [])

  const onSelectChange = (value) => {
    const selected = fromLeaguesOptions.find(option => option.value === value)
    setDetails({
      ...details,
      fromEventLeague: value,
      product: selected ? selected.product : details.product,
    })
  }

  return (
    <span className='form_content_popup_sim_golf'>
      <h2>{ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.choose_event_league_header') }</h2>
      <GlgPopupForm>
        <GlgFormInput>
          <GlgSelect
            searchable={ true }
            className='container_select'
            name='league[from]'
            items={ fromLeaguesOptions }
            extraInputs={ [
              { name: 'league[product]', key: 'product' },
              { name: 'league[is_express_event]', key: 'isExpressEvent' },
            ] }
            onChange={ onSelectChange }
            value={ details.fromEventLeague || '' }
            cloneEventSelectLeague={ true }
            noPreFill={ true }
            placeholder={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.choose_event_league_placeholder') }
          />
        </GlgFormInput>
      </GlgPopupForm>
    </span>
  )
}

SelectEventToClone.propTypes = {
  details: PropTypes.object.isRequired,
  setDetails: PropTypes.func.isRequired,
  fromLeaguesOptions: PropTypes.array.isRequired,
  getLeagueFieldDataSimGolf: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  fromLeaguesOptions: getFromLeaguesOptions(state),
})

export default connect(mapStateToProps)(SelectEventToClone)
